<template>
  <div id="login">
    <div class="tips-wrapper">
      <i class="icon iconfont icon-icon"></i>
      <p>易比得不会以任何理由要求您转账汇款，谨防诈骗。</p>
    </div>
    <div v-if="!user">
      <div class="login-tab">
        <div
          class="login-tab-left"
          v-bind:class="{'isTabActive':!isFormLogin}"
          @click="isFormLogin=false"
        >
          <span>扫码登录</span>
        </div>
        <div
          class="login-tab-right"
          v-bind:class="{'isTabActive':isFormLogin}"
          @click="isFormLogin=true"
        >
          <span>账户登录</span>
        </div>
      </div>
      <div class="wxLoginBox" v-if="!isFormLogin">
        <wxLogin @onLoginSuccess="onWxLoginSuccess" />
      </div>
      <keep-alive>
        <FormLogin @onLoginSuccess="onFormLoginSuccess" class="formLoginBox" v-if="isFormLogin" />
      </keep-alive>
      <!-- <div class="login-bottom"></div> -->
    </div>
    <div class="login-container" v-if="user">
      <SuccessLogin @onChangeRole="onChangeRole" v-if="!isChooseRole" />
      <ChooseRole v-if="isChooseRole" />
    </div>
  </div>
</template>
<script>
import wxLogin from '@/components/index/WxLogin';
import FormLogin from '@/components/index/FormLogin';
import SuccessLogin from '@/components/index/SuccessLogin';
import ChooseRole from '@/components/index/ChooseRole';
export default {
  name: 'login',
  components: {
    wxLogin,
    FormLogin,
    SuccessLogin,
    ChooseRole
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      isFormLogin: false,
      isChooseRole: false
    };
  },
  methods: {
    onFormLoginSuccess: function(user) {
      if (user.userRoles && user.userRoles.length > 1) {
        for (var i = 0; i < user.userRoles.length; i++) {
          if ('' + user.userRoles[i].roleCode === '8') {
            this.$store.dispatch('changeUserRole', 8);
            return;
          }
        }
      }

      this.$store.dispatch('setUser', user);
      this.$store.dispatch('setLoginType', 'form');
      if (user.userRoles && user.userRoles.length > 1) {
        this.user = user;
        this.isChooseRole = true;
      }
    },
    onWxLoginSuccess: function(user) {
      if (user.userRoles && user.userRoles.length > 1) {
        for (var i = 0; i < user.userRoles.length; i++) {
          if ('' + user.userRoles[i].roleCode === '8') {
            this.$store.dispatch('changeUserRole', 8);
            return;
          }
        }
      }
      this.$store.dispatch('setUser', user);
      this.$store.dispatch('setLoginType', 'wx');
      if (user.userRoles.length > 1) {
        this.user = user;
        this.isChooseRole = true;
      }
    },
    onChangeRole: function() {
      this.isChooseRole = true;
    }
  }
};
</script>
<style lang="less" scoped>
#login {
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 0px 20px #aaa;
  width: 346px;
  .tips-wrapper {
    background-color: rgba(255, 248, 240, 0.7);
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    p {
      color: #999;
      font-size: 12px;
      margin: 2px 0;
      display: inline;
    }
    i {
      color: #999;
      font-size: 16px;
      position: relative;
      top: 2px;
    }
  }
  .login-tab {
    height: 54px;
    font-size: 18px;
    font-family: 'microsoft yahei';
    text-align: center;
    border-bottom: 1px solid #f4f4f4;
    background-color: rgba(255, 255, 255, 0.5);
    .login-tab-left {
      width: 173px;
      height: 54px;
      float: left;
      cursor: pointer;
      position: relative;
      span {
        border-right: 1px solid #f4f4f4;
        position: absolute;
        width: 99%;
        left: 0;
        top: 18px;
      }
      &:hover {
        color: #e4393c;
        font-weight: 700;
      }
    }
    .login-tab-right {
      width: 173px;
      height: 54px;
      float: left;
      cursor: pointer;
      position: relative;
      span {
        position: absolute;
        width: 99%;
        left: 0;
        top: 18px;
      }
      &:hover {
        color: #e4393c;
        font-weight: 700;
      }
    }
    .isTabActive {
      color: #e4393c;
      font-weight: 700;
    }
  }
  .wxLoginBox {
    padding-top: 31px;
    background-color: rgba(255, 255, 255, 0.5);
    padding-bottom: 20px;
  }
  .login-bottom {
    padding-left: 20px;
    padding-right: 20px;
    line-height: 50px;
    border-top: 1px solid #f4f4f4;
    height: 50px;
    background-color: #fcfcfc;
  }
  .formLoginBox {
    padding: 33px 19px 20px 19px;
  }
  .login-container {
    padding: 14px;
    min-height: 380px;
  }
}
</style>
